function escapeCsvCell(value) {
  const str = value === null || value === undefined ? "" : String(value);
  if (/[",;\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportToCsv(filename, headers, rows) {
  const lines = [headers.map(escapeCsvCell).join(";")];
  rows.forEach((row) => {
    lines.push(row.map(escapeCsvCell).join(";"));
  });
  const csvContent = "﻿" + lines.join("\r\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
